import { TransToRedDirective } from './trans-to-red.directive';
import { DraggableDirective } from './draggable.directive';
import { NgModule } from '@angular/core';



@NgModule({
  declarations: [
    TransToRedDirective,
    DraggableDirective
  ],
  exports: [
    TransToRedDirective,
    DraggableDirective
  ]
})
export class CommonDirectiveModule { }
